<div class="flex flex-col min-h-screen bg-[#FAF8F5]">

  <!-- Draggable Demo Panel -->
  <!-- <div
    class="fixed z-[100] select-none"
    [style.left.px]="panelPos.x"
    [style.top.px]="panelPos.y"
    (pointerdown)="onPanelPointerDown($event)"
    (pointermove)="onPanelPointerMove($event)"
    (pointerup)="onPanelPointerUp()"
  >
    <div class="bg-white rounded-2xl shadow-2xl border border-gray-200 p-4 w-[230px]">
      <div class="flex items-center gap-2 mb-3 pb-2 border-b border-gray-100 cursor-grab active:cursor-grabbing" data-drag-handle>
        <div class="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
        <span class="text-[9px] font-bold uppercase tracking-[0.15em] text-gray-500">Prototype Demo</span>
        <span class="ml-auto text-[8px] text-gray-300">drag me</span>
      </div>

 
      <p class="text-[10px] text-gray-400 mb-2 font-bold uppercase tracking-wider">User Type</p>
      <div class="flex bg-gray-100 rounded-xl p-1 gap-1 mb-3">
        <button
          (click)="setUserType('new')"
          [class]="userType === 'new' ? 'flex-1 py-2 rounded-lg text-[10px] font-bold uppercase tracking-wider transition-all duration-300 bg-blue-500 text-white shadow-md' : 'flex-1 py-2 rounded-lg text-[10px] font-bold uppercase tracking-wider transition-all duration-300 text-gray-500 hover:text-gray-700'"
        >New User</button>
        <button
          (click)="setUserType('existing')"
          [class]="userType === 'existing' ? 'flex-1 py-2 rounded-lg text-[10px] font-bold uppercase tracking-wider transition-all duration-300 bg-green-500 text-white shadow-md' : 'flex-1 py-2 rounded-lg text-[10px] font-bold uppercase tracking-wider transition-all duration-300 text-gray-500 hover:text-gray-700'"
        >Existing</button>
      </div>


      <p class="text-[10px] text-gray-400 mb-1.5 font-bold uppercase tracking-wider">Live Context</p>
      <div class="bg-gray-50 rounded-lg p-2.5 min-h-[36px] flex flex-wrap gap-1.5">
        <ng-container *ngIf="contextSummary.length > 0; else noContext">
          <span *ngFor="let item of contextSummary" class="bg-[#600b0b] text-white text-[8px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider">{{ item }}</span>
        </ng-container>
        <ng-template #noContext>
          <span class="text-[9px] text-gray-400">No context set yet</span>
        </ng-template>
      </div>

      <div class="mt-2 flex items-center gap-2">
        <span class="text-[9px] text-gray-400 font-bold uppercase tracking-wider">Page:</span>
        <span class="text-[9px] font-bold text-[#600b0b] uppercase tracking-wider">{{ currentPageLabel }}</span>
      </div>

    
      <div class="mt-3 pt-2 border-t border-gray-100 space-y-1">
        <p class="text-[9px] text-gray-400 font-bold uppercase tracking-wider">Badges</p>
        <div class="flex items-center gap-2"><span class="w-2 h-2 bg-blue-500 rounded-full shrink-0"></span><span class="text-[9px] text-gray-500">New User Only</span></div>
        <div class="flex items-center gap-2"><span class="w-2 h-2 bg-green-500 rounded-full shrink-0"></span><span class="text-[9px] text-gray-500">Existing User Only</span></div>
        <div class="flex items-center gap-2"><span class="w-2 h-2 bg-purple-500 rounded-full shrink-0"></span><span class="text-[9px] text-gray-500">Personalized</span></div>
        <div class="flex items-center gap-2"><span class="w-2 h-2 bg-orange-500 rounded-full shrink-0"></span><span class="text-[9px] text-gray-500">Context-Aware</span></div>
      </div>
    </div>
  </div> -->

  <!-- Promotional Discount Band -->
  <div
    *ngIf="showPromoBanner"
    [class]="'text-white text-[9px] font-bold uppercase tracking-[0.3em] py-2 px-4 text-center z-50 leading-none flex items-center justify-center gap-2 relative ' + (userType === 'new' ? 'bg-[#600b0b]' : 'bg-[#1a5c1a]')"
  >
    <span *ngIf="userType === 'new'">
      Get 5% off on your first order! Use code:
      <span class="bg-white text-[#600b0b] px-2 py-0.5 rounded-sm ml-1 font-mono tracking-wider">5</span>
    </span>
    <span *ngIf="userType === 'existing'">
       back! Earn 2x loyalty points this week. Code:
      <span class="bg-white text-[#1a5c1a] px-2 py-0.5 rounded-sm ml-1 font-mono tracking-wider">LOYAL15</span>
    </span>
    <button (click)="dismissPromoBanner()" class="absolute right-4 text-white/60 hover:text-white transition-colors text-base leading-none" aria-label="Close">&times;</button>
  </div>

  <!-- Header -->
  <app-header></app-header>

  <!-- Main Content -->
  <main class="flex-grow">
    <div class="page-transition">
      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- Footer -->
  <app-footer></app-footer>

  <!-- NUR AI Panel -->
  <!-- <app-nur></app-nur> -->

  <!-- Dialogs (rendered at root level for proper z-index) -->
  <app-upload-dialog></app-upload-dialog>
  <app-pricing-detail-dialog></app-pricing-detail-dialog>
  <app-validation-dialog></app-validation-dialog>

  <!-- Toast Notifications -->
  <div class="fixed top-20 right-6 z-[200] flex flex-col gap-2 pointer-events-none">
    <div
      *ngFor="let toast of toasts"
      [class]="'pointer-events-auto flex items-center gap-3 px-4 py-3 rounded-xl shadow-2xl border min-w-[260px] max-w-[340px] ' + (toast.exiting ? 'toast-exit' : 'toast-enter') + ' ' + getToastBorderClass(toast)"
    >
      <div [class]="'w-8 h-8 rounded-full flex items-center justify-center shrink-0 ' + getToastIconBgClass(toast)">
        <!-- Cart icon -->
        <svg *ngIf="toast.type === 'cart'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-green-600"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
        <!-- Wishlist icon -->
        <svg *ngIf="toast.type === 'wishlist'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-rose-600"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
        <!-- Remove icon -->
        <svg *ngIf="toast.type === 'wishlist-remove'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-500"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>
        <!-- Info/Success icon -->
        <svg *ngIf="toast.type === 'success' || toast.type === 'info'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-blue-600"><polyline points="20 6 9 17 4 12"></polyline></svg>
      </div>
      <p class="text-sm text-gray-700 font-medium flex-1 font-serif">{{ toast.message }}</p>
      <button (click)="dismissToast(toast.id)" class="text-gray-300 hover:text-gray-500 transition-colors shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
  </div>

</div>
